import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 40 40"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-miterlimit": "10",
  "stroke-width": ".249",
  d: "M16.107 31.138c2.749 0 5.366-1.407 6.832-3.673a.28.28 0 0 0-.47-.3c-1.364 2.109-3.802 3.418-6.362 3.418a7.43 7.43 0 0 1-7.422-7.42c0-2.537 1.39-4.59 2.86-6.754.307-.451.622-.916.93-1.392a183 183 0 0 1 3.632-5.388c.328.47.986 1.417 1.796 2.617a.28.28 0 1 0 .464-.312c-1.17-1.735-2.026-2.941-2.034-2.953a.282.282 0 0 0-.457 0c-.018.026-1.862 2.62-3.872 5.729-.3.47-.62.934-.923 1.382-1.521 2.24-2.958 4.358-2.958 7.067a7.99 7.99 0 0 0 7.984 7.979Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-miterlimit": "10",
  "stroke-width": ".249",
  d: "M11.8 23.07a.283.283 0 0 0-.288-.27.28.28 0 0 0-.27.29 5.29 5.29 0 0 0 5.182 5.114h.006a.28.28 0 1 0 .005-.559A4.73 4.73 0 0 1 11.8 23.07ZM23.823 23.437a.28.28 0 0 0 .28-.28c0-2.708-1.437-4.826-2.957-7.067q-.225-.33-.451-.668a.28.28 0 1 0-.465.312q.223.338.453.67c1.47 2.169 2.86 4.217 2.86 6.754a.28.28 0 0 0 .28.28Z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-miterlimit": "10",
  "stroke-width": ".249",
  d: "M15.224 19.706a5.936 5.936 0 0 0 5.934 5.935 5.9 5.9 0 0 0 3.992-1.545l.97.97-.3.299a.813.813 0 0 0 0 1.15l3.667 3.667a.814.814 0 0 0 1.15 0l.998-.997a.813.813 0 0 0 0-1.15l-3.667-3.667a.815.815 0 0 0-1.15 0l-.3.3-1.163-1.164a.28.28 0 0 0-.399 0 5.374 5.374 0 1 1 .57-.672.28.28 0 0 0 .455.328 5.936 5.936 0 1 0-10.76-3.457zm11.992 5.058a.25.25 0 0 1 .358 0l3.668 3.666a.25.25 0 0 1 .055.277.3.3 0 0 1-.055.082l-.998.998a.253.253 0 0 1-.358 0l-3.67-3.666a.25.25 0 0 1-.055-.276.3.3 0 0 1 .055-.082z"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-miterlimit": "10",
  "stroke-width": ".249",
  d: "M18.353 19.066v-.256a.28.28 0 0 0-.56 0v.256a.28.28 0 0 0 .169.274.28.28 0 0 0 .39-.274ZM21.006 21.155v.255a.28.28 0 0 0 .56 0v-.255a.28.28 0 0 0-.17-.274.28.28 0 0 0-.39.274ZM20.992 19.427a.28.28 0 0 0-.237-.317l-.252-.037a.28.28 0 1 0-.082.554l.253.037h.041a.28.28 0 0 0 .277-.237ZM19.393 17.193l-.19.171a.28.28 0 0 0-.075.302.28.28 0 0 0 .452.113l.19-.172a.28.28 0 0 0-.377-.414ZM18.11 21.91a.28.28 0 0 0 .394-.052l.156-.2a.28.28 0 0 0-.257-.458.28.28 0 0 0-.187.118l-.156.2a.28.28 0 0 0 .05.391ZM20.282 23.365a.28.28 0 0 0-.292.362.28.28 0 0 0 .241.195l.255.024h.026a.28.28 0 0 0 .025-.559z"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }